import Root from '../../pages/Root'
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { Provider } from 'react-redux'
import store from '../../redux/store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2D4170',
    },
    secondary: {
      main: '#81BB41',
    },
  },
})

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Root />
        <ToastContainer />
      </ThemeProvider>
    </Provider>
  )
}

export default App
